import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function PaginationButton(_ref) {
  let {
    onClick,
    page,
    title,
    disabled,
    beforeIcon
  } = _ref;
  return /*#__PURE__*/_jsx(Button, {
    theme: "stroke_secondary",
    disabled: disabled,
    onClick: () => onClick(page),
    beforeIcon: beforeIcon,
    children: title
  });
}